"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function CompanyStory() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.5;
  return <section className="relative min-h-screen w-full overflow-hidden">
      {}
      <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1497483/img/lithiumcore_mining_site_aerial.png)",
      transform: `translateY(${parallaxOffset}px)`,
      willChange: "transform"
    }} />

      {}
      <div className="absolute inset-0 bg-dark-background/40" />

      {}
      <div className="relative z-10 flex min-h-screen items-center justify-center px-6 py-24">
        <div ref={contentRef} className={`max-w-4xl transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-16 opacity-0"}`}>
          {}
          <div className={`rounded-lg bg-background/95 px-8 py-12 shadow-strong backdrop-blur-sm transition-all duration-[800ms] ease-[var(--ease-out-back)] md:px-16 md:py-20 ${isVisible ? "scale-100 opacity-100" : "scale-95 opacity-0"}`}>
            {}
            <h1 className="mb-8 font-display text-4xl font-bold leading-tight text-primary md:text-5xl lg:text-6xl">
              Powering the Future of Clean Energy
            </h1>

            {}
            <div className="space-y-6 text-lg leading-relaxed text-foreground md:text-xl">
              <p>
                united mining power was founded on a simple yet powerful mission: to responsibly source and deliver high-quality lithium 
                that fuels the global transition to electric vehicles and renewable energy storage. Headquartered in the United States 
                with active operations across Africa, we bridge continents and industries to meet the growing demand for battery metals.
              </p>
              <p>
                Our story is one of commitment—to operational excellence, environmental stewardship, and the communities where we operate. 
                We believe that mining can be a force for positive change when guided by strong governance, transparent reporting, 
                and a relentless focus on safety and sustainability.
              </p>
              <p>
                From exploration to production, every milestone we achieve is driven by our core values: credibility, integrity, 
                and a deep respect for the land and people who make our work possible. As the world accelerates toward a low-carbon future, 
                united mining power stands ready to supply the essential materials that will power tomorrow's innovations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}